<template>
  <v-form>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="blue"
    ></v-progress-linear>
    <v-card>
      <HeaderDividerBlock headerText="Create New Role"></HeaderDividerBlock>
      <v-container class="pa-6">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              dense
              v-model="form.name"
              required
              label="Role Name*"
            ></v-text-field>
          </v-col>
          <!-- branch -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="branchPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllBranch"
                        @click="toggleSelectAllBranch()"
                        label="Branch"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in branchPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.branch"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <!-- store -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="storePer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllStore"
                        @click="toggleSelectAllStore()"
                        label="Store"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in storePer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.store"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <!-- customer -->
          <v-col xs="12" sm="12" md="12" lg="6" xl="3">
            <v-simple-table v-if="customerPer">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllCustomer"
                        @click="toggleSelectAllCustomer()"
                        label="Customer"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in customerPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.customer"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Suppliers -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="suppliersPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllSuppliers"
                        @click="toggleSelectAllSuppliers()"
                        label="Suppliers"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in suppliersPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.suppliers"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Product -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="productPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllProduct"
                        @click="toggleSelectAllProduct()"
                        label="Product"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in productPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.product"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Product Tax -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="productTaxPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllProductTax"
                        @click="toggleSelectAllProductTax()"
                        label="Product Tax"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in productTaxPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.productTax"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Requisition -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="requisitionPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllRequisition"
                        @click="toggleSelectAllRequisition()"
                        label="Requisition"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in requisitionPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.requisition"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Purchase Order -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="purchaseOrderPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllPurchaseOrder"
                        @click="toggleSelectAllPurchaseOrder()"
                        label="Purchase Order"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in purchaseOrderPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.purchase_order"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- GRN -->
          <v-col xs="12" sm="12" md="12" lg="6" xl="3" v-if="grnPer.length > 0">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllGrn"
                        @click="toggleSelectAllGrn()"
                        label="GRN"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in grnPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.grn"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Stock -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="stockPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllStock"
                        @click="toggleSelectAllStock()"
                        label="Stock"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in stockPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.stock"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Batch -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="batchPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllBatch"
                        @click="toggleSelectAllBatch()"
                        label="Batch"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in batchPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.batch"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Stock Transfer -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="stockTransferPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllStockTransfer"
                        @click="toggleSelectAllStockTransfer()"
                        label="Stock Transfer"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in stockTransferPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.stock_transfer"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Goods Return Note -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="goodsReturnNotePer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllGoodsReturnNote"
                        @click="toggleSelectAllGoodsReturnNote()"
                        label="Goods Return Note"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in goodsReturnNotePer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.goods_return_note"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Expenses -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="expensesPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllExpenses"
                        @click="toggleSelectAllExpenses()"
                        label="Expenses"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in expensesPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.expenses"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Expense Types -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="expenseTypesPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllExpenseTypes"
                        @click="toggleSelectAllExpenseTypes()"
                        label="Expense Types"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in expenseTypesPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.expense_types"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- GL Account -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="glAccountPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllGlAccount"
                        @click="toggleSelectAllGlAccount()"
                        label="GL Account"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in glAccountPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.gl_account"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- GL Sub Headers -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="glSubHeadersPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllGlSubHeaders"
                        @click="toggleSelectAllGlSubHeaders()"
                        label="GL Sub Headers"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in glSubHeadersPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.gl_sub_headers"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- GL Transactions -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="glTransactionsPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllGlTransactions"
                        @click="toggleSelectAllGlTransactions()"
                        label="GL Transactions"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in glTransactionsPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.GL_Transactions"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Trial Balance -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="trialBalancePer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllTrialBalance"
                        @click="toggleSelectAllTrialBalance()"
                        label="Trial Balance"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in trialBalancePer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.trial_balance"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- invoice -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="invoicePer.length > 0"
          >
            <v-simple-table v-if="invoicePer.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllInvoice"
                        @click="toggleSelectAllInvoice()"
                        label="Invoice"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in invoicePer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.invoice"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Payment Voucher -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="paymentVoucherPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllPaymentVoucher"
                        @click="toggleSelectAllPaymentVoucher()"
                        label="Payment Voucher"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in paymentVoucherPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.payment_voucher"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Company Bank Account -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="companyBankAccountPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllCompanyBankAccount"
                        @click="toggleSelectAllCompanyBankAccount()"
                        label="Company Bank Account"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in companyBankAccountPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.company_bank_account"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Bin Card -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="binCardPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllBinCard"
                        @click="toggleSelectAllBinCard()"
                        label="Bin Card"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in binCardPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.bin_card"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Other Income Types -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="otherIncomeTypesPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllOtherIncomeTypes"
                        @click="toggleSelectAllOtherIncomeTypes()"
                        label="Other Income Types"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in otherIncomeTypesPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.other_income_types"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Income Entries -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="incomeEntriesPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllIncomeEntries"
                        @click="toggleSelectAllIncomeEntries()"
                        label="Income Entries"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in incomeEntriesPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.income_entries"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- settings -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="settingsPer.length > 0"
          >
            <v-simple-table v-if="settingsPer.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllSettings"
                        @click="toggleSelectAllSettings()"
                        label="Settings"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in settingsPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.settings"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- User -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="userPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllUser"
                        @click="toggleSelectAllUser()"
                        label="User"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in userPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.user"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Role -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="rolePer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllRole"
                        @click="toggleSelectAllRole()"
                        label="Role"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in rolePer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.role"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"> </v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="#00B3FF"
              dark
              depressed
              :disabled="loading"
              block
              @click="create()"
              >Create</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
    <Snackbars
      :text="'Validation error please scroll up'"
      :snackbar="snackbarError"
      :color="'red'"
      @classSnackbar="closeSnackbar"
    />
  </v-form>
</template>
<script>
import Alert from "@/components/shared/Alert";
import { RoleService } from "@/services/role-service.js";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";

export default {
  name: "CreateRole",
  components: { Alert, Snackbars, HeaderDividerBlock },
  props: ["name"],
  data: () => ({
    form: {
      name: "",
      guard_name: "api",
      user: [],
      role: [],
      project: [],
      branch: [],
      store: [],
      customer: [],
      suppliers: [],
      product: [],
      productTax: [],
      requisition: [],
      purchase_order: [],
      grn: [],
      stock: [],
      batch: [],
      stock_transfer: [],
      goods_return_note: [],
      expenses: [],
      expense_types: [],
      gl_account: [],
      gl_sub_headers: [],
      GL_Transactions: [],
      trial_balance: [],
      invoice: [],
      payment_voucher: [],
      company_bank_account: [],
      bin_card: [],
      other_income_types: [],
      income_entries: [],
      settings: [],
      calendar: null,
      task: [],
      document: [],
      data: [],
      userPer: [],
      projectPer: [],
      customerPer: [],
      taskPer: [],
      calendarPer: [],
      invoicePer: [],
      documentPer: [],
      settingsPer: [],
    },

    snackbar: false,
    isCheckedUser: false,
    isCheckedProject: false,
    isCheckedCustomer: false,
    isCheckedTask: false,
    isCheckedCalendar: false,
    isCheckedInvoice: false,
    isCheckedDocument: false,
    isCheckedSettings: false,
    snackbarError: false,
    perArray: [],
    successMsg: "Role has been created successfully",
    errors: null,
    loading: false,
    permissions: [],
    selectAllUser: false,
    selectAllCustomer: false,
    selectAllTask: false,
    selectAllProject: false,
    selectAllInvoice: false,
    selectAllDocument: false,
    selectAllSettings: false,
    userPer: [],
    rolePer: [],
    projectPer: [],
    customerPer: [],
    taskPer: [],
    calendarPer: [],
    invoicePer: [],
    documentPer: [],
    settingsPer: [],
    branchPer: [],
    storePer: [],
    suppliersPer: [],
    productPer: [],
    productTaxPer: [],
    requisitionPer: [],
    purchaseOrderPer: [],
    grnPer: [],
    stockPer: [],
    batchPer: [],
    stockTransferPer: [],
    goodsReturnNotePer: [],
    expensesPer: [],
    expenseTypesPer: [],
    glAccountPer: [],
    glSubHeadersPer: [],
    glTransactionsPer: [],
    trialBalancePer: [],
    paymentVoucherPer: [],
    companyBankAccountPer: [],
    binCardPer: [],
    otherIncomeTypesPer: [],
    incomeEntriesPer: [],
    selectAllRole: false,
    selectAllBranch: false,
    selectAllStore: false,
    selectAllSuppliers: false,
    selectAllProduct: false,
    selectAllProductTax: false,
    selectAllRequisition: false,
    selectAllPurchaseOrder: false,
    selectAllGrn: false,
    selectAllStock: false,
    selectAllBatch: false,
    selectAllStockTransfer: false,
    selectAllGoodsReturnNote: false,
    selectAllExpenses: false,
    selectAllExpenseTypes: false,
    selectAllGlAccount: false,
    selectAllGlSubHeaders: false,
    selectAllGlTransactions: false,
    selectAllTrialBalance: false,
    selectAllPaymentVoucher: false,
    selectAllCompanyBankAccount: false,
    selectAllBinCard: false,
    selectAllOtherIncomeTypes: false,
    selectAllIncomeEntries: false,
    isCheckedRole: false,
    isCheckedBranch: false,
    isCheckedStore: false,
    isCheckedSuppliers: false,
    isCheckedProduct: false,
    isCheckedProductTax: false,
    isCheckedRequisition: false,
    isCheckedPurchaseOrder: false,
    isCheckedGrn: false,
    isCheckedStock: false,
    isCheckedBatch: false,
    isCheckedStockTransfer: false,
    isCheckedGoodsReturnNote: false,
    isCheckedExpenses: false,
    isCheckedExpenseTypes: false,
    isCheckedGlAccount: false,
    isCheckedGlSubHeaders: false,
    isCheckedGlTransactions: false,
    isCheckedTrialBalance: false,
    isCheckedPaymentVoucher: false,
    isCheckedCompanyBankAccount: false,
    isCheckedBinCard: false,
    isCheckedOtherIncomeTypes: false,
    isCheckedIncomeEntries: false,
  }),

  watch: {},

  mounted() {
    this.getPermissionList();
  },

  methods: {
    create() {
      this.loading = true;
      this.errors = null;

      if (this.isCheckedUser) {
        const permissionsStringUser = this.userPer.join(",");
        this.form.user = permissionsStringUser;
      }

      if (this.isCheckedRole) {
        const permissionsStringRole = this.rolePer.join(",");
        this.form.role = permissionsStringRole;
      }
      if (this.form.role) {
        this.perArray.push(this.form.role);
      }

      if (this.isCheckedProject) {
        const permissionsString2 = this.projectPer.join(",");
        this.form.project = permissionsString2;
      }

      if (this.isCheckedCustomer) {
        const permissionsString3 = this.customerPer.join(",");
        this.form.customer = permissionsString3;
      }

      if (this.isCheckedTask) {
        const permissionsString4 = this.taskPer.join(",");
        this.form.task = permissionsString4;
      }

      if (this.isCheckedCalendar) {
        const permissionsString5 = this.calendarPer.join(",");
        this.form.calendar = permissionsString5;
      }

      if (this.isCheckedInvoice) {
        const permissionsString6 = this.invoicePer.join(",");
        this.form.invoice = permissionsString6;
      }

      if (this.isCheckedDocument) {
        const permissionsString7 = this.documentPer.join(",");
        this.form.document = permissionsString7;
      }

      if (this.isCheckedSettings) {
        const permissionsString8 = this.settingsPer.join(",");
        this.form.settings = permissionsString8;
      }

      if (this.isCheckedBranch) {
        const permissionsStringBranch = this.branchPer.join(",");
        this.form.branch = permissionsStringBranch;
      }
      if (this.isCheckedStore) {
        const permissionsStringStore = this.storePer.join(",");
        this.form.store = permissionsStringStore;
      }
      if (this.form.branch) {
        this.perArray.push(this.form.branch);
      }
      if (this.form.store) {
        this.perArray.push(this.form.store);
      }
      // Suppliers
      if (this.isCheckedSuppliers) {
        const permissionsStringSuppliers = this.suppliersPer.join(",");
        this.form.suppliers = permissionsStringSuppliers;
      }
      if (this.form.suppliers) {
        this.perArray.push(this.form.suppliers);
      }

      // Product
      if (this.isCheckedProduct) {
        const permissionsStringProduct = this.productPer.join(",");
        this.form.product = permissionsStringProduct;
      }
      if (this.form.product) {
        this.perArray.push(this.form.product);
      }

      // Product Tax
      if (this.isCheckedProductTax) {
        const permissionsStringProductTax = this.productTaxPer.join(",");
        this.form.productTax = permissionsStringProductTax;
      }
      if (this.form.productTax) {
        this.perArray.push(this.form.productTax);
      }

      // Requisition
      if (this.isCheckedRequisition) {
        const permissionsStringRequisition = this.requisitionPer.join(",");
        this.form.requisition = permissionsStringRequisition;
      }
      if (this.form.requisition) {
        this.perArray.push(this.form.requisition);
      }

      // Purchase Order
      if (this.isCheckedPurchaseOrder) {
        const permissionsStringPurchaseOrder = this.purchaseOrderPer.join(",");
        this.form.purchase_order = permissionsStringPurchaseOrder;
      }
      if (this.form.purchase_order) {
        this.perArray.push(this.form.purchase_order);
      }

      // GRN
      if (this.isCheckedGrn) {
        const permissionsStringGrn = this.grnPer.join(",");
        this.form.grn = permissionsStringGrn;
      }
      if (this.form.grn) {
        this.perArray.push(this.form.grn);
      }

      // Stock
      if (this.isCheckedStock) {
        const permissionsStringStock = this.stockPer.join(",");
        this.form.stock = permissionsStringStock;
      }
      if (this.form.stock) {
        this.perArray.push(this.form.stock);
      }

      // Batch
      if (this.isCheckedBatch) {
        const permissionsStringBatch = this.batchPer.join(",");
        this.form.batch = permissionsStringBatch;
      }
      if (this.form.batch) {
        this.perArray.push(this.form.batch);
      }

      // Stock Transfer
      if (this.isCheckedStockTransfer) {
        const permissionsStringStockTransfer = this.stockTransferPer.join(",");
        this.form.stock_transfer = permissionsStringStockTransfer;
      }
      if (this.form.stock_transfer) {
        this.perArray.push(this.form.stock_transfer);
      }

      // Goods Return Note
      if (this.isCheckedGoodsReturnNote) {
        const permissionsStringGoodsReturnNote = this.goodsReturnNotePer.join(
          ","
        );
        this.form.goods_return_note = permissionsStringGoodsReturnNote;
      }
      if (this.form.goods_return_note) {
        this.perArray.push(this.form.goods_return_note);
      }

      // Expenses
      if (this.isCheckedExpenses) {
        const permissionsStringExpenses = this.expensesPer.join(",");
        this.form.expenses = permissionsStringExpenses;
      }
      if (this.form.expenses) {
        this.perArray.push(this.form.expenses);
      }

      // Expense Types
      if (this.isCheckedExpenseTypes) {
        const permissionsStringExpenseTypes = this.expenseTypesPer.join(",");
        this.form.expense_types = permissionsStringExpenseTypes;
      }
      if (this.form.expense_types) {
        this.perArray.push(this.form.expense_types);
      }

      // GL Account
      if (this.isCheckedGlAccount) {
        const permissionsStringGlAccount = this.glAccountPer.join(",");
        this.form.gl_account = permissionsStringGlAccount;
      }
      if (this.form.gl_account) {
        this.perArray.push(this.form.gl_account);
      }

      // GL Sub Headers
      if (this.isCheckedGlSubHeaders) {
        const permissionsStringGlSubHeaders = this.glSubHeadersPer.join(",");
        this.form.gl_sub_headers = permissionsStringGlSubHeaders;
      }
      if (this.form.gl_sub_headers) {
        this.perArray.push(this.form.gl_sub_headers);
      }

      // GL Transactions
      if (this.isCheckedGlTransactions) {
        const permissionsStringGlTransactions = this.glTransactionsPer.join(
          ","
        );
        this.form.GL_Transactions = permissionsStringGlTransactions;
      }
      if (this.form.GL_Transactions) {
        this.perArray.push(this.form.GL_Transactions);
      }

      // Trial Balance
      if (this.isCheckedTrialBalance) {
        const permissionsStringTrialBalance = this.trialBalancePer.join(",");
        this.form.trial_balance = permissionsStringTrialBalance;
      }
      if (this.form.trial_balance) {
        this.perArray.push(this.form.trial_balance);
      }

      // Payment Voucher
      if (this.isCheckedPaymentVoucher) {
        const permissionsStringPaymentVoucher = this.paymentVoucherPer.join(
          ","
        );
        this.form.payment_voucher = permissionsStringPaymentVoucher;
      }
      if (this.form.payment_voucher) {
        this.perArray.push(this.form.payment_voucher);
      }

      // Company Bank Account
      if (this.isCheckedCompanyBankAccount) {
        const permissionsStringCompanyBankAccount = this.companyBankAccountPer.join(
          ","
        );
        this.form.company_bank_account = permissionsStringCompanyBankAccount;
      }
      if (this.form.company_bank_account) {
        this.perArray.push(this.form.company_bank_account);
      }

      // Bin Card
      if (this.isCheckedBinCard) {
        const permissionsStringBinCard = this.binCardPer.join(",");
        this.form.bin_card = permissionsStringBinCard;
      }
      if (this.form.bin_card) {
        this.perArray.push(this.form.bin_card);
      }

      // Other Income Types
      if (this.isCheckedOtherIncomeTypes) {
        const permissionsStringOtherIncomeTypes = this.otherIncomeTypesPer.join(
          ","
        );
        this.form.other_income_types = permissionsStringOtherIncomeTypes;
      }
      if (this.form.other_income_types) {
        this.perArray.push(this.form.other_income_types);
      }

      // Income Entries
      if (this.isCheckedIncomeEntries) {
        const permissionsStringIncomeEntries = this.incomeEntriesPer.join(",");
        this.form.income_entries = permissionsStringIncomeEntries;
      }
      if (this.form.income_entries) {
        this.perArray.push(this.form.income_entries);
      }

      if (this.form.user) {
        this.perArray.push(this.form.user);
      }

      if (this.form.project) {
        this.perArray.push(this.form.project);
      }

      if (this.form.customer) {
        this.perArray.push(this.form.customer);
      }

      if (this.form.task) {
        this.perArray.push(this.form.task);
      }

      if (this.form.calendar) {
        this.perArray.push(this.form.calendar);
      }

      if (this.form.invoice) {
        this.perArray.push(this.form.invoice);
      }

      if (this.form.document) {
        this.perArray.push(this.form.document);
      }

      if (this.form.settings) {
        this.perArray.push(this.form.settings);
      }

      this.form.data = this.perArray;

      let fd = new FormData();

      fd.append("name", this.form.name);
      fd.append("guard_name", this.form.guard_name);
      fd.append("permissions", this.form.data || "");

      RoleService.createRole(fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.reset();
            this.snackbar = true;
            this.snackbarError = false;
            this.$router.push("/roles");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          window.scrollTo(0, 0);
        });
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    toggleSelectAllUser() {
      if (this.selectAllUser) {
        this.isCheckedUser = true;
        this.form.user = this.userPer;
      } else {
        this.isCheckedUser = false;
        this.form.user = [];
      }
    },

    toggleSelectAllProject() {
      if (this.selectAllProject) {
        this.isCheckedProject = true;
        this.form.project = this.projectPer;
      } else {
        this.isCheckedProject = false;
        this.form.project = [];
      }
    },

    toggleSelectAllInvoice() {
      if (this.selectAllInvoice) {
        this.isCheckedInvoice = true;
        this.form.invoice = this.invoicePer;
      } else {
        this.isCheckedInvoice = false;
        this.form.invoice = [];
      }
    },

    toggleSelectAllDocument() {
      if (this.selectAllDocument) {
        this.isCheckedDocument = true;
        this.form.document = this.documentPer;
      } else {
        this.isCheckedDocument = false;
        this.form.document = [];
      }
    },

    toggleSelectAllSettings() {
      if (this.selectAllSettings) {
        this.isCheckedSettings = true;
        this.form.settings = this.settingsPer;
      } else {
        this.isCheckedSettings = false;
        this.form.settings = [];
      }
    },

    toggleSelectAllRole() {
      if (this.selectAllRole) {
        this.isCheckedRole = true;
        this.form.role = this.rolePer;
      } else {
        this.isCheckedRole = false;
        this.form.role = [];
      }
    },

    toggleSelectAllBranch() {
      if (this.selectAllBranch) {
        this.isCheckedBranch = true;
        this.form.branch = this.branchPer;
      } else {
        this.isCheckedBranch = false;
        this.form.branch = [];
      }
    },
    toggleSelectAllStore() {
      if (this.selectAllStore) {
        this.isCheckedStore = true;
        this.form.store = this.storePer;
      } else {
        this.isCheckedStore = false;
        this.form.store = [];
      }
    },
    toggleSelectAllCustomer() {
      if (this.selectAllCustomer) {
        this.isCheckedCustomer = true;
        this.form.customer = this.customerPer;
      } else {
        this.isCheckedCustomer = false;
        this.form.customer = [];
      }
    },
    toggleSelectAllSuppliers() {
      if (this.selectAllSuppliers) {
        this.isCheckedSuppliers = true;
        this.form.suppliers = this.suppliersPer;
      } else {
        this.isCheckedSuppliers = false;
        this.form.suppliers = [];
      }
    },

    // Product
    toggleSelectAllProduct() {
      if (this.selectAllProduct) {
        this.isCheckedProduct = true;
        this.form.product = this.productPer;
      } else {
        this.isCheckedProduct = false;
        this.form.product = [];
      }
    },

    // Product Tax
    toggleSelectAllProductTax() {
      if (this.selectAllProductTax) {
        this.isCheckedProductTax = true;
        this.form.productTax = this.productTaxPer;
      } else {
        this.isCheckedProductTax = false;
        this.form.productTax = [];
      }
    },

    // Requisition
    toggleSelectAllRequisition() {
      if (this.selectAllRequisition) {
        this.isCheckedRequisition = true;
        this.form.requisition = this.requisitionPer;
      } else {
        this.isCheckedRequisition = false;
        this.form.requisition = [];
      }
    },

    // Purchase Order
    toggleSelectAllPurchaseOrder() {
      if (this.selectAllPurchaseOrder) {
        this.isCheckedPurchaseOrder = true;
        this.form.purchase_order = this.purchaseOrderPer;
      } else {
        this.isCheckedPurchaseOrder = false;
        this.form.purchase_order = [];
      }
    },

    // GRN
    toggleSelectAllGrn() {
      if (this.selectAllGrn) {
        this.isCheckedGrn = true;
        this.form.grn = this.grnPer;
      } else {
        this.isCheckedGrn = false;
        this.form.grn = [];
      }
    },

    // Stock
    toggleSelectAllStock() {
      if (this.selectAllStock) {
        this.isCheckedStock = true;
        this.form.stock = this.stockPer;
      } else {
        this.isCheckedStock = false;
        this.form.stock = [];
      }
    },

    // Batch
    toggleSelectAllBatch() {
      if (this.selectAllBatch) {
        this.isCheckedBatch = true;
        this.form.batch = this.batchPer;
      } else {
        this.isCheckedBatch = false;
        this.form.batch = [];
      }
    },

    // Stock Transfer
    toggleSelectAllStockTransfer() {
      if (this.selectAllStockTransfer) {
        this.isCheckedStockTransfer = true;
        this.form.stock_transfer = this.stockTransferPer;
      } else {
        this.isCheckedStockTransfer = false;
        this.form.stock_transfer = [];
      }
    },

    // Goods Return Note
    toggleSelectAllGoodsReturnNote() {
      if (this.selectAllGoodsReturnNote) {
        this.isCheckedGoodsReturnNote = true;
        this.form.goods_return_note = this.goodsReturnNotePer;
      } else {
        this.isCheckedGoodsReturnNote = false;
        this.form.goods_return_note = [];
      }
    },

    // Expenses
    toggleSelectAllExpenses() {
      if (this.selectAllExpenses) {
        this.isCheckedExpenses = true;
        this.form.expenses = this.expensesPer;
      } else {
        this.isCheckedExpenses = false;
        this.form.expenses = [];
      }
    },

    // Expense Types
    toggleSelectAllExpenseTypes() {
      if (this.selectAllExpenseTypes) {
        this.isCheckedExpenseTypes = true;
        this.form.expense_types = this.expenseTypesPer;
      } else {
        this.isCheckedExpenseTypes = false;
        this.form.expense_types = [];
      }
    },

    // GL Account
    toggleSelectAllGlAccount() {
      if (this.selectAllGlAccount) {
        this.isCheckedGlAccount = true;
        this.form.gl_account = this.glAccountPer;
      } else {
        this.isCheckedGlAccount = false;
        this.form.gl_account = [];
      }
    },

    // GL Sub Headers
    toggleSelectAllGlSubHeaders() {
      if (this.selectAllGlSubHeaders) {
        this.isCheckedGlSubHeaders = true;
        this.form.gl_sub_headers = this.glSubHeadersPer;
      } else {
        this.isCheckedGlSubHeaders = false;
        this.form.gl_sub_headers = [];
      }
    },

    // GL Transactions
    toggleSelectAllGlTransactions() {
      if (this.selectAllGlTransactions) {
        this.isCheckedGlTransactions = true;
        this.form.GL_Transactions = this.glTransactionsPer;
      } else {
        this.isCheckedGlTransactions = false;
        this.form.GL_Transactions = [];
      }
    },

    // Trial Balance
    toggleSelectAllTrialBalance() {
      if (this.selectAllTrialBalance) {
        this.isCheckedTrialBalance = true;
        this.form.trial_balance = this.trialBalancePer;
      } else {
        this.isCheckedTrialBalance = false;
        this.form.trial_balance = [];
      }
    },

    // Payment Voucher
    toggleSelectAllPaymentVoucher() {
      if (this.selectAllPaymentVoucher) {
        this.isCheckedPaymentVoucher = true;
        this.form.payment_voucher = this.paymentVoucherPer;
      } else {
        this.isCheckedPaymentVoucher = false;
        this.form.payment_voucher = [];
      }
    },

    // Company Bank Account
    toggleSelectAllCompanyBankAccount() {
      if (this.selectAllCompanyBankAccount) {
        this.isCheckedCompanyBankAccount = true;
        this.form.company_bank_account = this.companyBankAccountPer;
      } else {
        this.isCheckedCompanyBankAccount = false;
        this.form.company_bank_account = [];
      }
    },

    // Bin Card
    toggleSelectAllBinCard() {
      if (this.selectAllBinCard) {
        this.isCheckedBinCard = true;
        this.form.bin_card = this.binCardPer;
      } else {
        this.isCheckedBinCard = false;
        this.form.bin_card = [];
      }
    },

    // Other Income Types
    toggleSelectAllOtherIncomeTypes() {
      if (this.selectAllOtherIncomeTypes) {
        this.isCheckedOtherIncomeTypes = true;
        this.form.other_income_types = this.otherIncomeTypesPer;
      } else {
        this.isCheckedOtherIncomeTypes = false;
        this.form.other_income_types = [];
      }
    },

    // Income Entries
    toggleSelectAllIncomeEntries() {
      if (this.selectAllIncomeEntries) {
        this.isCheckedIncomeEntries = true;
        this.form.income_entries = this.incomeEntriesPer;
      } else {
        this.isCheckedIncomeEntries = false;
        this.form.income_entries = [];
      }
    },

    getPermissionList() {
      this.loading = true;
      RoleService.getPermissionList()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.permissions = response.data;
            this.userPer = this.permissions.user || [];
            this.branchPer = this.permissions.branch || [];
            this.storePer = this.permissions.store || [];
            this.customerPer = this.permissions.customer || [];
            this.suppliersPer = this.permissions.Suppliers || [];
            this.productPer = this.permissions.product || [];
            this.productTaxPer = this.permissions.productTax || [];
            this.requisitionPer = this.permissions.requisition || [];
            this.purchaseOrderPer = this.permissions.purchase_order || [];
            this.grnPer = this.permissions.grn || [];
            this.stockPer = this.permissions.stock || [];
            this.batchPer = this.permissions.batch || [];
            this.stockTransferPer = this.permissions.stock_transfer || [];
            this.goodsReturnNotePer = this.permissions.goods_return_note || [];
            this.expensesPer = this.permissions.expenses || [];
            this.expenseTypesPer = this.permissions.expense_types || [];
            this.glAccountPer = this.permissions.gl_account || [];
            this.glSubHeadersPer = this.permissions.gl_sub_headers || [];
            this.glTransactionsPer = this.permissions.GL_Transactions || [];
            this.trialBalancePer = this.permissions.trial_balance || [];
            this.invoicePer = this.permissions.invoice || [];
            this.paymentVoucherPer = this.permissions.payment_voucher || [];
            this.companyBankAccountPer =
              this.permissions.company_bank_account || [];
            this.binCardPer = this.permissions.bin_card || [];
            this.otherIncomeTypesPer =
              this.permissions.other_income_types || [];
            this.incomeEntriesPer = this.permissions.income_entries || [];
            this.settingsPer = this.permissions.setting || [];
            this.rolePer = this.permissions.role || [];
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },

    reset() {
      this.form = [];
    },
    formatLabel(label) {
      const parts = label.split(".");
      return parts[parts.length - 1].replace(/_/g, " ");
    },
  },
};
</script>
